export const UNITS = ["ton", "kg", "adet", "balya"];
export const CATEGORIES = ["yem", "kaba yem", "konsantre", "katkı", "buzağı maması", "ağız sütü", "malzeme", "yakıt", "temizlik", "veteriner", "diğer"];
export const FREQS = ["haftalık", "aylık"];
export const EMPTY = { name: "", category: "yem", unit: "kg", quantity: 0, unit_price: 0, count_frequency: "aylık", min_stock: 0, lead_time_days: 3, supplier: "", notes: "" };
